import hasValidNationalHealthIdentifierChecksum from './hasValidNationalHealthIdentifierChecksum';

/**
 * Generic over `T` rather than `BeneficiaryFormData` itself, so the FormData never has to import
 * its own constraint back (`guides/forms.md` §1.1). Reads nothing beyond its own value.
 */
function isNationalHealthIdentifierValid<T>(value: string | null | undefined, _formData: T): boolean {
	if (value === null || value === undefined || value === '') {
		return true;
	}

	return hasValidNationalHealthIdentifierChecksum(value);
}

export default isNationalHealthIdentifierValid;
